import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { VisitorStatus } from '@/models'

export type GuestDetailsResponse = {
  visitor: {
    notes?: string
    name?: string
    status: VisitorStatus
    email?: string
    phone?: string
    company?: string
    type?: string
    bannedReason?: string
    startTime?: string
    endTime?: string
    createdBy?: string
    permissionToEnter?: boolean
    customAccess?: boolean
    keylessAccess?: boolean
    keyAccess?: boolean
    pinCode?: boolean
    guestId?: string | number
    vendorId?: string | number
    residentName?: string
    unitNumber?: string
    residentPhone?: string
  }
  checkIns: { date: string | number }[]
}

export const getGuestDetailsQueryKey = (guestId: number) => ['useGetGuestDetails', { guestId }]

export const getGuestDetails = async (guestId: number): Promise<GuestDetailsResponse> => {
  const response = await authAPI.get<GuestDetailsResponse>(`/client-guest/${guestId}`)
  return response.data
}

export const useGetGuestDetails = (guestId: number) => {
  return useQuery({
    gcTime: 0,
    queryFn: () => getGuestDetails(guestId),
    queryKey: getGuestDetailsQueryKey(guestId),
  })
}
